import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { MapPinIcon, PhoneIcon, HomeIcon } from 'lucide-react';
export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <motion.nav initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 1,
    ease: [0.16, 1, 0.3, 1]
  }} className={`fixed top-0 left-0 right-0 z-50 flex items-center justify-between px-6 md:px-14 py-6 transition-colors duration-500 ${scrolled ? 'bg-bg-glass backdrop-blur-md text-primary' : 'bg-transparent text-white'}`} data-id="element-126">
      {/* Left group — back-to-site CTA + brand */}
      <div className="flex items-center gap-3 md:gap-5 shrink-0" data-id="element-127">
        {/* Back to main website */}
        <a href="https://jrpdi.com.ph" target="_blank" rel="noopener noreferrer" aria-label="Back to JRP main website" className={`inline-flex items-center gap-2 rounded-full px-3 py-2 text-sm font-light tracking-wide transition-colors ${scrolled ? 'bg-primary/5 text-primary hover:bg-primary/10' : 'bg-white/15 text-white hover:bg-white/25 backdrop-blur-sm'}`} data-id="element-128">
          <HomeIcon className="w-4 h-4 shrink-0" strokeWidth={1.5} data-id="element-129" />
          <span className="hidden sm:inline" data-id="element-130">Home</span>
        </a>

        {/* Brand */}
        <a href="#top" className="flex items-center gap-2.5 group" data-id="element-131">
          <img src="https://cdn.magicpatterns.com/uploads/1XQazF3bMRoBsuVY3Rx58f/2.png" alt="JRP" className={`h-5 md:h-6 w-auto transition-[filter] duration-500 ${scrolled ? '' : 'brightness-0 invert'}`} data-id="element-132" />
          <span className="font-heading text-base md:text-lg font-light tracking-tight" data-id="element-133">
            Homes
          </span>
        </a>
      </div>

      {/* Right group — address + contact */}
      <div className="flex items-center gap-4 md:gap-8" data-id="element-134">
        {/* Location */}
        <a href="#top" className={`flex items-center gap-2 transition-colors ${scrolled ? 'text-accent' : 'text-white'}`} data-id="element-135">
          <MapPinIcon className="w-4 h-4 shrink-0" strokeWidth={1.5} aria-hidden="true" data-id="element-136" />
          <span className="text-sm font-light tracking-wide" data-id="element-137">
            <span className="md:hidden" data-id="element-138">Campanilla</span>
            <span className="hidden md:inline" data-id="element-139">
              35 Campanilla, Ayala Westgrove Heights
            </span>
          </span>
        </a>

        {/* Contact — jumps to the enquiry section */}
        <a href="#contact" className={`flex items-center gap-2 transition-opacity hover:opacity-80 ${scrolled ? 'text-primary' : 'text-white/90'}`} aria-label="Go to contact section" data-id="element-140">
          <PhoneIcon className="w-4 h-4 shrink-0" strokeWidth={1.5} aria-hidden="true" data-id="element-141" />
          <span className="hidden sm:inline text-sm font-light tracking-wide" data-id="element-142">
            +63 917 526 0969
          </span>
        </a>
      </div>
    </motion.nav>;
}